import {
    CALCULATE_LOAN_OFFER,
    REQUEST_CALCULATE_LOAN_OFFER_DETAILS,
    RECEIVE_CALCULATE_LOAN_OFFER_DETAILS,
} from '../actions/loanOffer'



const DEFAULT_OFFER_STATE =   {
    monthlyPmt: 0,
    amt: 5000,
    len: 36,
    offerdata: {isFetching: true}
};


export function offer(state = DEFAULT_OFFER_STATE, action) {
    switch (action.type) {
        case CALCULATE_LOAN_OFFER: {        
            return {...state, amt: action.amt, len: action.len, monthlyPmt: action.monthlyPmt};
        }
        case REQUEST_CALCULATE_LOAN_OFFER_DETAILS: {
            // Keep any previously-fetched values around so the UI can choose to
            // either show the stale numbers or a loader; just flip the flag.
            return {
                ...state,
                offerdata: { ...(state.offerdata || {}), isFetching: true }
            };
        }
        case RECEIVE_CALCULATE_LOAN_OFFER_DETAILS: {
            var newstate = {
                ...state, 
                 offerdata: {...action.response.value, isFetching: false}
            }
            return newstate;
        }
        default: {
            return state;
        }
    }
}
